import {
  EntityHeaderItem,
  EntityList,
  EntityListHeader,
} from '../../../../../components/entityList/entityList';
import { headerNames } from '../customTasks.constants';
import React, { useEffect, useState } from 'react';
import { SortableList, Spinner, Text } from '@bloobirds-it/flamingo-ui';
import styles from '../../businessAssetsPage.module.css';
import { EntityCard } from '../../../../../components/entityList/entityCard/entityCard';
import { CustomTaskCard } from '../customTasksCard/customTaskCard';
import { SearchLogs } from '../../../../../../assets/svg';
import { useCustomTaskCreation } from '../hooks/useCustomTaskCreation';
import { api } from '../../../../../utils/api';
import { KeyedMutator } from 'swr';
import classnames from 'clsx';
import { CustomTask } from '@bloobirds-it/types';

const emptyTask: CustomTask = {
  name: '',
  description: '',
  icon: 'questionCircle',
  iconColor: 'bloobirds',
  enabled: false,
  fields: [],
};

interface CustomTaskListProps {
  customTasks: CustomTask[];
  mutate: KeyedMutator<CustomTask[]>;
}

const customTaskSort = (a: CustomTask, b: CustomTask) => {
  if (b.enabled && !a.enabled) {
    return 1;
  } else if (!b.enabled && a.enabled) {
    return -1;
  } else {
    return b.ordering - a.ordering;
  }
};
export const CustomTasksList = ({ customTasks, mutate }: CustomTaskListProps) => {
  const [customTasksList, setCustomTasksList] = useState<CustomTask[]>(
    customTasks?.sort(customTaskSort),
  );

  useEffect(() => {
    setCustomTasksList(customTasks?.sort(customTaskSort));
  }, [customTasks]);

  const { customTaskCreation, setCustomTaskCreation } = useCustomTaskCreation();

  const handleTaskUpdated = (customTask: CustomTask) => {
    mutate();
  };

  const handleTaskCreated = (customTask: CustomTask) => {
    setCustomTaskCreation(false);
    setCustomTasksList([customTask, ...customTasksList]);
    mutate();
  };

  const handleUpdateOrder = (customTasks: CustomTask[]) => {
    api
      .post<CustomTask[]>(
        '/utils/customTask/order',
        customTasks.map((task, index) => ({
          customTaskId: task.id,
          ordering: customTasks.length - index - 1,
        })),
      )
      .then(response => {
        setCustomTasksList([...response.data.sort(customTaskSort)]);
      });
  };
  return (
    <>
      {customTasks || customTaskCreation ? (
        <EntityList className={undefined}>
          {customTasks?.length > 0 || customTaskCreation ? (
            <>
              <EntityListHeader className={undefined}>
                {headerNames.map(header => (
                  <EntityHeaderItem
                    label={header?.label}
                    key={header?.label}
                    order={undefined}
                    onClick={undefined}
                    flexEnd={false}
                    icon={header.icon}
                    tooltip={header.tooltip}
                  />
                ))}
              </EntityListHeader>
              {customTaskCreation && (
                <EntityCard>
                  <CustomTaskCard
                    customTask={emptyTask}
                    isNew={true}
                    onCardUpdated={handleTaskCreated}
                  />
                </EntityCard>
              )}
              <SortableList
                className={styles._tbody}
                data={customTasksList}
                keyExtractor={tm => tm?.id}
                onReorder={data => {
                  setCustomTasksList([...data]);
                  handleUpdateOrder([...data]);
                }}
                renderItem={({ item, innerRef, containerProps, handleProps, isDragging }) => (
                  <EntityCard
                    ref={innerRef}
                    {...containerProps}
                    {...handleProps}
                    className={classnames(isDragging && styles._card__dragging, styles.taskRow)}
                  >
                    <CustomTaskCard customTask={item} onCardUpdated={handleTaskUpdated} />
                  </EntityCard>
                )}
              />
            </>
          ) : (
            <div className={styles._no_results__contents}>
              <SearchLogs className={styles._no_results__img} />
              <Text size="xl" weight="bold" align="center" color="softPeanut">
                Still no custom tasks have been created
              </Text>
            </div>
          )}
        </EntityList>
      ) : (
        <Spinner name="dots" />
      )}
    </>
  );
};
